<template>
  <form
    v-show="isShow"
    :class="{ formClass: isShow }"
    @submit.prevent="resetSubmit"
    @keydown="resetform.errors.clear($event.target.name)"
    class="pb-2"
  >
    <div class="desc text-center">
      <p v-if="resetform.errors.any()" class="text-danger">
        გთხოვთ შეიყვანოთ სწორი მონაცმები
      </p>
      <p v-else-if="password_msg">
        პაროლის გასანახლებელი ბმული გამოგზავნილია თქვენს მეილზე!
      </p>
      <p v-else>
        შეიყვანეთ თქვენი მობილური და თქვენ მიიღებთ პაროლის გასანახლებელ ბმულს მეილზე!
      </p>
    </div>
    <div class="signUp">
      <span>
        <input
          v-model="resetform.phone"
          class="form"
          placeholder="მობილური"
          name="phone"
          autocomplete="off"
        />
        <span class="underline"></span>

        <p
          class="text-danger mt-m-20"
          v-if="resetform.errors.has('phone') && resetform.phone == ''"
        >
          გთხოვთ შეიყვანოთ თქვენი მობილური
        </p>

        <p
          class="text-danger mt-m-20"
          v-else-if="
            resetform.errors.has('phone') &&
            resetform.errors.get('phone') == 'The phone has already been taken.'
          "
        >
          ამ იმეილით უკვე არსებობს უზერი
        </p>

        <p
          class="text-danger mt-m-20"
          v-else-if="resetform.errors.has('phone') && resetform.phone != ''"
        >
          გთხოვთ შეიყვანოთ სწორი მობილური
        </p>
      </span>
    </div>
    <div class="text-center">
      <button
        type="submit"
        :class="{ regsending: sending }"
        :disabled="resetform.errors.any()"
        class="b-shadow-none btn btn-primary btn-link btn-lg"
      >
        გაგაზავნა
        <i class="fas fa-paper-plane"></i>
      </button>
    </div>
    <button @click="$emit('showLogin')" type="button" class="btn btn-light btn-block regBtn">
      ავტორიზაცია
    </button>
  </form>
</template>

<script>
import { Form } from '../../../form/form.js';
import LoginForm from './login-form';
import RegisterForm from './register-form';
export default {
  props: ['unauth', 'isShow'],
  components: {
    LoginForm,
    RegisterForm,
  },
  data() {
    return {
      password_msg: false,
      sending: false,
      resetform: new Form({}),
    };
  },
  methods: {
    resetSubmit() {
      this.sending = true;
      axios
        .post('/password/phone', this.resetform.data())
        .then((res) => {
          this.password_msg = true;
          this.sending = false;
          // location.reload();
        })
        .catch((error) => {
          this.sending = false;
          this.resetform.errors.record(error.response.data.errors);
        });
    },
  },
  mounted() {},
};
</script>
